module.exports = __webpack_public_path__ + "img/e_2_9_g.552c096b.png";